<form [formGroup]="form" autocomplete="off">
    <div>
        <mat-form-field class="card-inline  margin-right-small">
            <mat-label>Número</mat-label>
            <input type="number" matInput formControlName="Number">
            <mat-error *ngIf="f.Number.errors && f.Number.errors.required">
                Debe ingresar el número de liquidación
            </mat-error>
        </mat-form-field>

        <mat-form-field class="margin-right-small">
            <input matInput autocomplete="off" formControlName="PayDate" [matDatepicker]="pickerPayDate" placeholder="Fecha de pago">
            <mat-datepicker-toggle matSuffix [for]="pickerPayDate"></mat-datepicker-toggle>
            <mat-datepicker #pickerPayDate></mat-datepicker>
            <mat-error *ngIf="f.PayDate.errors && f.PayDate.errors.required">
                Debe ingresar la fecha de pago
            </mat-error>
        </mat-form-field>

        <mat-form-field class="margin-right-small">
            <mat-select formControlName="MedicalFeePeriod" placeholder="Período">
                <mat-option *ngFor="let medicalFeePeriodFilter of medicalFeePeriodFilters" [value]="medicalFeePeriodFilter">
                    {{ medicalFeePeriodFilter.Name }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="margin-right-small">
            <mat-select formControlName="MedicalFeeYearPeriod" placeholder="Año">
                <mat-option *ngFor="let medicalFeeYearPeriod of medicalFeeYearPeriods" [value]="medicalFeeYearPeriod">
                    {{ medicalFeeYearPeriod }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="margin-right-small">
            <input type="text" #client matInput placeholder="Médico" formControlName="Physician" [matAutocomplete]="autPhysician">
            <mat-autocomplete #autPhysician="matAutocomplete" [displayWith]="filterCompletePhysician.displayFn">
                <mat-option *ngFor="let physician of filteredPhysicianOptions | async" [value]="physician">
                    {{ physician.Name }}
                </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="f.Physician.errors &&
              ( f.Physician.errors.required || 
                f.Physician.errors.validAutoCompleteSelect)">
                Debe ingresar al médico
            </mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-select formControlName="TaxpayerType" placeholder="Tipo contribuyente impositivo">
                <mat-option *ngFor="let taxpayerType of taxpayerTypes" [value]="taxpayerType">
                    {{ taxpayerType.Name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="card-box-medium">
        <mat-label>Retenciones</mat-label>
        <button (click)="showMedicalFeeWithholdTaxDialog()" type="button" mat-mini-fab><mat-icon>add</mat-icon></button>
        <table formArrayName="MedicalFeeWithholdTaxAmounts" class="table" mat-table [dataSource]="medicalFeeWithholdTaxAmountDataSource">

            <ng-container matColumnDef="TaxName">
                <th class="table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Retención
                </th>
                <td class="table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                    <div> {{ fMedicalFeeWithholdTaxAmounts.controls[index].value.MedicalFeeWithholdTaxName }} </div>
                </td>
                <td class="table-footer" mat-footer-cell *matFooterCellDef><b>Total</b> </td>
            </ng-container>

            <ng-container matColumnDef="Aliquot">
                <th class="table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Alícuota
                </th>
                <td class="table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                    <div>{{ fMedicalFeeWithholdTaxAmounts.controls[index].value.Aliquot }} </div>
                </td>
                <td class="table-footer" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>

            <ng-container matColumnDef="Amount">
                <th class="table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Monto
                </th>
                <td class="table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                    <div> {{ fMedicalFeeWithholdTaxAmounts.controls[index].value.Amount }} </div>
                </td>
                <td class="table-footer" mat-footer-cell *matFooterCellDef> <b>{{ medicalFeeWithholdTaxAmount }}</b> </td>
            </ng-container>

            <ng-container matColumnDef="Delete">
                <th class="table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Monto
                </th>
                <td class="table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                    <mat-icon class="cursor-default" (click)="deleteFeeWithholdTax(index)">delete</mat-icon>
                </td>
                <td class="table-footer" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>

            <tr mat-footer-row class="table-footer" *matFooterRowDef="medicalFeeWithholdTaxAmountDisplayedColumns"></tr>
            <tr mat-header-row class="table-header" *matHeaderRowDef="medicalFeeWithholdTaxAmountDisplayedColumns; sticky: true"></tr>
            <tr mat-row class="table-cell" *matRowDef="let row; let i = index; columns: medicalFeeWithholdTaxAmountDisplayedColumns;"></tr>
        </table>
    </div>

    <div class="card-box-medium">
        <mat-label>Montos manuales</mat-label>
        <button (click)="showMedicalFeeTaxDialog()" type="button" mat-mini-fab><mat-icon>add</mat-icon></button>
        <table formArrayName="MedicalFeeTaxAmounts" class="table" mat-table [dataSource]="medicalFeeTaxAmountDataSource">

            <ng-container matColumnDef="TaxName">
                <th class="table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Impuesto
                </th>
                <td class="table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                    <div> {{ fMedicalFeeTaxAmounts.controls[index].value.TaxType.Name }} </div>
                </td>
                <td class="table-footer" mat-footer-cell *matFooterCellDef> <b>Total</b> </td>
            </ng-container>

            <ng-container matColumnDef="Aliquot">
                <th class="table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Alícuota
                </th>
                <td class="table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                    <div> {{ fMedicalFeeTaxAmounts.controls[index].value.AliquotTax.Percentage }} </div>
                </td>
                <td class="table-footer" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>

            <ng-container matColumnDef="Amount">
                <th class="table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Monto impuesto
                </th>
                <td class="table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                    <div> {{ fMedicalFeeTaxAmounts.controls[index].value.Amount }} </div>
                </td>
                <td class="table-footer" mat-footer-cell *matFooterCellDef> <b> {{ medicalFeeTaxAmount }}</b> </td>
            </ng-container>

            <ng-container matColumnDef="AmountBase">
                <th class="table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Monto
                </th>
                <td class="table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                    <div> {{ fMedicalFeeTaxAmounts.controls[index].value.AmountBase }} </div>
                </td>
                <td class="table-footer" mat-footer-cell *matFooterCellDef> <b>{{ medicalFeeTaxAmountBase }}</b> </td>
            </ng-container>

            <ng-container matColumnDef="Description">
                <th class="table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Descripción
                </th>
                <td class="table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                    <div><b>{{ fMedicalFeeTaxAmounts.controls[index].value.Description }}</b></div>
                </td>
                <td class="table-footer" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>

            <ng-container matColumnDef="Delete">
                <th class="table-header resizable-column" mat-header-cell *matHeaderCellDef>

                </th>
                <td class="table-cell" mat-cell *matCellDef="let row; let index = index" [formGroupName]="index">
                    <mat-icon class="cursor-default" (click)="deleteMedicalFeeTax(index)">delete</mat-icon>
                </td>
                <td class="table-footer" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>

            <tr mat-footer-row class="table-footer" *matFooterRowDef="medicalFeeTaxAmountDisplayedColumns"></tr>
            <tr mat-header-row class="table-header" *matHeaderRowDef="medicalFeeTaxAmountDisplayedColumns; sticky: true"></tr>
            <tr mat-row class="table-cell" *matRowDef="let row; let i = index; columns: medicalFeeTaxAmountDisplayedColumns;"></tr>
        </table>
    </div>



    <div *ngIf="medicalFeePracticeTaxAmounts.length > 0" class="card-box-medium margin-right-small">
        <mat-label>Montos por prestaciones</mat-label>
        <table class="table" mat-table [dataSource]="medicalFeePracticeTaxAmountDataSource">


            <ng-container matColumnDef="TaxName">
                <th class="table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Impuesto
                </th>
                <td class="table-cell" mat-cell *matCellDef="let element">
                    <div> {{ element.TaxName }} </div>
                </td>
                <td class="table-footer" mat-footer-cell *matFooterCellDef> <b>Total</b> </td>
            </ng-container>

            <ng-container matColumnDef="Aliquot">
                <th class="table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Alícuota
                </th>
                <td class="table-cell" mat-cell *matCellDef="let element">
                    <div> {{ element.AliquotTax.Name }} </div>
                </td>
                <td class="table-footer" mat-footer-cell *matFooterCellDef> </td>
            </ng-container>
            <ng-container matColumnDef="Amount">
                <th class="table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Monto IVA
                </th>
                <td class="table-cell" mat-cell *matCellDef="let element">
                    <div> {{ element.Amount }} </div>
                </td>
                <td class="table-footer" mat-footer-cell *matFooterCellDef><b> {{ totalPracticeTaxAmount }} </b></td>
            </ng-container>
            <ng-container matColumnDef="AmountBase">
                <th class="table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Monto
                </th>
                <td class="table-cell" mat-cell *matCellDef="let element">
                    <div> {{ element.AmountBase }} </div>
                </td>
                <td class="table-footer" mat-footer-cell *matFooterCellDef><b> {{ totalPracticeTaxAmountBase }} </b> </td>
            </ng-container>

            <tr mat-footer-row class="table-footer" *matFooterRowDef="medicalFeePracticeTaxAmountDisplayedColumns">
                <tr mat-header-row class="table-header" *matHeaderRowDef="medicalFeePracticeTaxAmountDisplayedColumns; sticky: true"></tr>
                <tr mat-row class="table-cell" *matRowDef="let row; columns: medicalFeePracticeTaxAmountDisplayedColumns;"></tr>
        </table>
    </div>
    <div class="card-box-medium margin-top-large">
        <mat-label> <b> {{ medicalFeeTotalText }}</b> </mat-label>
    </div>
</form>